<template>
  <div class="nursingmanagement clearfix">
    <div class="nursingmanagement-left">
      <el-row style="
          height: 54px;
          line-height: 54px;
          background: #f9f7fa;
          border: 1px #f1eff2 solid;
        ">
        <el-col :span="9">
          <span style="height: 54px; line-height: 54px; margin-left: 10px"><img src="@/assets/common/juxing.png" alt=""
              style="vertical-align: middle" /></span>
          <span style="height: 54px; line-height: 54px; font-size: 16px">{{
            nursingManagement.careTeam
          }}</span></el-col>
        <el-col :span="3" :offset="4">
          <span>
            <img src="@/assets/beadhouse/huanbanzhang_icon.png" alt="" style="vertical-align: middle; cursor: pointer"
              @click="handleReplaceMonitor" />
          </span>
        </el-col>
        <el-col :span="3" :offset="1">
          <span style="height: 54px; line-height: 54px">
            <img src="@/assets/beadhouse/bigjia.png" alt="" style="vertical-align: middle; cursor: pointer"
              @click="handleAddNursingItem" />
          </span>
        </el-col>
        <el-col :span="3" :offset="1">
          <span style="height: 54px; line-height: 54px">
            <img src="@/assets/beadhouse/shanchu_icon.png" alt="" style="vertical-align: middle; cursor: pointer"
              @click="handleDeleteNursingItem" />
          </span>
        </el-col>
      </el-row>
      <el-row style="width: 50%; margin: 10px auto">
        <el-row>
          <el-col>
            <span v-if="showImg"><img src="@/assets/beadhouse/jian.png" alt="" class="handedness"
                @click="handleMinusImg" /></span>
            <span v-else><img src="@/assets/beadhouse/jia.png" alt="" class="handedness" @click="handleAddImg" /></span>
            <span>{{ nursingManagement.allScheduling }}</span>
          </el-col>
          <el-col v-for="(item, index) in teamGroupList" :key="index"
            :class="{ teamGroupListA: isTrueA, teamGroupListB: isTrueB }">
            <el-radio v-model="teamGroupRadio" :label="item.id" @change="changeRadio">{{ item.name }}</el-radio>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <div class="nursingmanagement-right">
      <el-row>
        <el-row style="
            height: 54px;
            line-height: 54px;
            background: #f9f7fa;
            border: 1px #f1eff2 solid;
          ">
          <el-col :span="2">
            <span style="height: 54px; line-height: 54px; margin-left: 10px"><img src="@/assets/common/juxing.png" alt=""
                style="vertical-align: middle" /></span>
          </el-col>
          <el-col :span="4" :offset="9" style="font-size: 16px">{{
            nursingManagement.responsibleRoom
          }}</el-col>
          <el-col :span="2" :offset="7" align="right">
            <span style="height: 54px; line-height: 54px; margin-right: 10px"><img src="@/assets/beadhouse/bigjia.png"
                alt="" style="vertical-align: middle; cursor: pointer" @click="handleAddMonitorItemRoom" /></span>
          </el-col>
        </el-row>
        <el-row class="clearfix" style="border: 1px #f1eff2 solid; border-top: none">
          <div class="item" v-for="(item, index) in roomList" :key="index">
            <img src="@/assets/beadhouse/dafangzi.png" alt="" />
            <div>{{ item.roomNo }}</div>
          </div>
        </el-row>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-row style="
            height: 54px;
            line-height: 54px;
            background: #f9f7fa;
            border: 1px #f1eff2 solid;
          ">
          <el-col :span="2">
            <span style="height: 54px; line-height: 54px; margin-left: 10px"><img src="@/assets/common/juxing.png" alt=""
                style="vertical-align: middle" /></span>
          </el-col>
          <el-col :span="4" :offset="9" style="font-size: 16px">{{
            nursingManagement.nursingDetail
          }}</el-col>
          <el-col :span="2" :offset="7" align="right">
            <span style="height: 54px; line-height: 54px; margin-right: 10px"><img src="@/assets/beadhouse/bigjia.png"
                alt="" style="vertical-align: middle; cursor: pointer" @click="handleAddMonitorItemMember" /></span>
          </el-col>
        </el-row>
        <el-row>
          <!-- 表格内容栏 -->
          <kt-table :tableHeaderColor="tableHeaderColor" :tableRowStyle="tableRowStyle" v-loading="loading"
            :element-loading-text="nursingManagement.loading" :data="pageResult" :columns="filterColumns"
            :operationWidth="200" :showEdit="true" :showRemove="true" :showDelete="false" :showLook="false"
            @findPage="findPage" @handleEdit="handleEdit" @handleRemove="handleRemove"
            @refreshPageRequest="refreshPageRequest">
          </kt-table>
        </el-row>
      </el-row>
    </div>
    <!-- 更换班长的dialog模态框 -->
    <el-dialog :title="nursingManagement.exchangeMonitor" width="40%" :visible.sync="dialogVisibleReplaceMonitor"
      :close-on-click-modal="false">
      <el-form :model="dataFormReplaceMonitor" label-width="100px" :rules="dataFormReplaceMonitorRules"
        ref="dataFormReplaceMonitor" label-position="right">
        <el-form-item :label="nursingManagement.itemName" prop="monitorItemName">
          <el-select v-model="dataFormReplaceMonitor.monitorItemName"
            :placeholder="nursingManagement.pleaseSelectItemName" style="width: 80%"
            @change="handleChangeMonitorItemName">
            <el-option v-for="item in monitorItemNameOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="nursingManagement.monitorName" prop="monitorName">
          <el-select v-model="dataFormReplaceMonitor.monitorName" :placeholder="nursingManagement.PleaseSelectMonitor"
            style="width: 80%">
            <el-option v-for="item in monitorNameOptions" :key="item.userId" :label="item.realName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="固定班长名:" prop="monitorName">
          <el-select v-model="dataFormReplaceMonitor.monitorNameb" disabled :placeholder="nursingManagement.PleaseSelectMonitor"
            style="width: 80%">
            <el-option v-for="item in monitorNameOptions" :key="item.userId" :label="item.realName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleReplaceMonitor = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormReplaceMonitor"
          :loading="replaceMonitorLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 新增 护工班组的dialog模态框 -->
    <el-dialog :title="nursingManagement.newNursingTeam" width="30%" :visible.sync="dialogVisibleAddNursingItem"
      :close-on-click-modal="false">
      <el-form :model="addNursingItem" label-width="100px" :rules="addNursingItemRules" ref="addNursingItem"
        label-position="right">
        <el-form-item :label="nursingManagement.careGroupName" prop="name">
          <el-input v-model.trim="addNursingItem.name" auto-complete="off"
            :placeholder="nursingManagement.PleaseEnterNursingGroupName" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item :label="nursingManagement.monitorName" prop="userId">
          <el-select v-model="addNursingItem.userId" :placeholder="nursingManagement.PleaseSelectMonitor"
            style="width: 80%">
            <el-option v-for="item in undistributedList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleAddNursingItem = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormAddNursingItem"
          :loading="addNursingItemLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 新增 班组房间的dialog模态框 -->
    <el-dialog :title="nursingManagement.NewTeamRooms" width="50%" :visible.sync="dialogVisibleAddMonitorItemRoom"
      :close-on-click-modal="false" @close="closeAddMonitorItemRoom">
      <el-form :model="addMonitorItemRoom" label-width="100px" :rules="addMonitorItemRoomRules" ref="addMonitorItemRoom"
        label-position="right">
        <el-row style="width: 80%; margin: 0 auto">
          <el-col :span="12">
            <el-form-item :label="nursingManagement.itemName" prop="monitorItemName">
              <el-select v-model="addMonitorItemRoom.monitorItemName"
                :placeholder="nursingManagement.pleaseSelectItemName" style="width: 80%"
                @change="handleChangeMonitorItemRoom">
                <el-option v-for="item in monitorItemNameOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="nursingManagement.monitorName" prop="monitorName">
              <el-input v-model="addMonitorItemRoom.monitorName" auto-complete="off" style="width: 80%">a</el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 80%; margin: 0 auto">
          <el-col :span="9" :offset="1">
            <el-row class="roomInfo">
              <el-row class="roomInfoText">
                {{ nursingManagement.roomInformation }}
              </el-row>
              <el-row class="roomInfoContent">
                <el-col :span="18" :offset="6">
                  <span v-if="showBuildImg"><img src="@/assets/beadhouse/jian.png" alt="" class="handedness"
                      @click="handleBuildMinusImg" /></span>
                  <span v-else><img src="@/assets/beadhouse/jia.png" alt="" class="handedness"
                      @click="handleBuildAddImg" /></span>
                  <span>{{ nursingManagement.allBuild }}</span>
                </el-col>
                <el-col v-for="(item, index) in buildRoomList" :key="index" :class="{
                  buildRoomListA: isBuildTrueA,
                  buildRoomListB: isBuildTrueB,
                }">
                  <el-col :span="18" :offset="6" class="buildingName" :title="item.buildingName">
                    <span v-if="item.showRoomImg"><img src="@/assets/beadhouse/jian.png" alt="" class="handedness"
                        @click="handleRoomMinusImg(index)" /></span>
                    <span v-else><img src="@/assets/beadhouse/jia.png" alt="" class="handedness"
                        @click="handleRoomAddImg(index, item.buildingId)" /></span>
                    <span>{{ item.buildingName }}</span>
                  </el-col>
                  <el-col :class="{
                    roomListA: item.isRoomTrueA,
                    roomListB: item.isRoomTrueB,
                  }">
                    <el-checkbox-group v-model="checkedRoom" @change="handleCheckedRoom" class="checkboxRoom">
                      <el-checkbox v-for="(room, i) in itemRoomList" :label="room.roomId" :key="i" :title="room.roomNo"
                        class="roomNo">{{ room.roomNo }}</el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                </el-col>
              </el-row>
            </el-row>
          </el-col>
          <el-col :span="3" :offset="1" class="btn">
            <el-row class="addBtn"><el-button v-show="addBtnShow" :size="size" type="primary"
                @click="submitFormAddMonitorItemRoom">新增</el-button></el-row>
            <el-row class="deleteBtn"><el-button v-show="deleteBtnShow" :size="size" type="danger"
                @click="submitFormDeleteItemRoom">删除</el-button></el-row>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-row class="roomInfo">
              <el-row class="roomInfoText">
                {{ nursingManagement.selectedRoom }}
              </el-row>
              <el-row class="roomInfoContent">
                <el-checkbox-group v-model="chooseRoom" @change="handleChooseRoomList"
                  style="width: 65%; margin: 10px auto">
                  <el-checkbox v-for="(item, i) in choosedRoomList" :label="item.roomId" :key="i"
                    style="margin-top: 10px">{{ item.roomNo }}</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <!--
      -->
    </el-dialog>
    <!-- 新增班组成员的dialog模态框 -->
    <el-dialog :title="nursingManagement.newTeamMembers" width="45%" :visible.sync="dialogVisibleAddMonitorItemMember"
      :close-on-click-modal="false">
      <el-form :model="addMonitorItemMember" label-width="100px" :rules="addMonitorItemMemberRules"
        ref="addMonitorItemMember" label-position="right">
        <el-row style="width: 90%; margin: 0 auto">
          <el-col :span="12">
            <el-form-item :label="nursingManagement.itemName" prop="nursingGroupId">
              <el-select v-model="addMonitorItemMember.nursingGroupId"
                :placeholder="nursingManagement.pleaseSelectItemName" style="width: 80%"
                @change="handleChangeMonitorItemMember">
                <el-option v-for="item in monitorItemNameOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="nursingManagement.monitorName" prop="monitorName">
              <el-input v-model="addMonitorItemMember.monitorName" auto-complete="off" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="width: 80%; margin: 0 auto">
          <el-row style="
              height: 54px;
              line-height: 54px;
              border: 1px #f1eff2 solid;
              text-align: center;
              font-size: 16px;
            ">{{ nursingManagement.addMembers }}</el-row>
          <el-row style="
              min-height: 100px;
              border: 1px #f1eff2 solid;
              border-top: none;
            ">
            <el-checkbox-group v-model="checkedNursing" @change="handleCheckedNursing"
              style="width: 65%; margin: 10px auto">
              <el-checkbox v-for="(nursing, i) in unNursing" :label="nursing.value" :key="i" style="margin-top: 10px">{{
                nursing.label }}</el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleAddMonitorItemMember = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormAddMonitorItemMember"
          :loading="addMonitorItemMemberLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 更改护士班组的dialog模态框 -->
    <el-dialog :title="nursingManagement.changeNurseGroup" width="30%" :visible.sync="dialogVisibleEditNursingItem"
      :close-on-click-modal="false">
      <el-form :model="editNursingItem" label-width="100px" :rules="editNursingItemRules" ref="editNursingItem"
        label-position="right">
        <el-form-item :label="nursingManagement.nursingName" prop="nursingName">
          <el-input v-model="editNursingItem.nursingName" :disabled="true" auto-complete="off"
            style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item :label="nursingManagement.careGroupName" prop="nursingItem">
          <el-select v-model="editNursingItem.nursingItem" style="width: 80%"
            @change="$set(editNursingItem, editNursingItem.nursingItem, $event)">
            <el-option v-for="item in nursingItemOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleEditNursingItem = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormEditNursingItem"
          :loading="editNursingItemLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  name: "NursingManagement",
  components: { KtTable, KtButton },
  data() {
    return {
      nursingManagement: {
        careTeam: "护理班组",
        allScheduling: "所有班组",
        responsibleRoom: "班组负责房间",
        nursingDetail: "护工详细信息",
        loading: "拼命加载中...",
        exchangeMonitor: "班组更换班长:",
        itemName: "班组名称:",
        monitorName: "班长名:",
        pleaseSelectItemName: "请选择班组名称",
        PleaseSelectMonitor: "请选择班长",
        newNursingTeam: "新增护工班组",
        careGroupName: "护工组名:",
        PleaseEnterNursingGroupName: "请输入护工组名",
        PleaseSelectMonitor: "请选择班长",
        NewTeamRooms: "新增班组房间",
        newTeamMembers: "新增班组成员",
        addMembers: "添加成员",
        changeNurseGroup: "更改护士班组",
        nursingName: "护工姓名:",
        notEmpty: "不能为空",
        messageLenTwototen: "长度在 2到 10 的字符",
        roomInformation: "房间信息",
        selectedRoom: "已选择房间",
        allBuild: "所有楼栋"
      }, //引入 lang 里面的字符串资源,
      loading: true,
      size: "medium", //按钮的尺寸
      //班组更换班长的dialog配置
      dialogVisibleReplaceMonitor: false, //班组更换班长
      replaceMonitorLoading: false, //班组更换班长的按钮加载loading
      //班组更换班长数据源
      dataFormReplaceMonitor: {
        monitorItemName: "",
        monitorName: "",
        monitorNameb:""
      },
      dataFormReplaceMonitorRules: {
        monitorItemName: [
          {
            required: true,
            message: "班组名不能为空",
            trigger: "change",
          },
        ],
        monitorName: [
          {
            required: true,
            message: "班组名不能为空",
            trigger: "change",
          },
        ],
      },
      monitorItemNameOptions: [], //更换班长dialog中的班组集合
      monitorNameOptions: [], //更换班长dialog中的护工集合
      teamGroupList: [], //所有班组的集合
      teamGroupRadio: "", //默认选中的radio
      showImg: true, //默认是减号
      isTrueA: true, //默认使用teamGroupListA的样式
      isTrueB: false,
      undistributedList: [], //未被分配的班长集合
      //新增护工班组的dialog配置
      dialogVisibleAddNursingItem: false,
      addNursingItemLoading: false,
      addNursingItem: {},
      addNursingItemRules: {
        name: [
          {
            required: true,
            message: "班组名不能为空",
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: "班组名不能为空",
          },
        ],
        userId: [
          {
            required: true,
            message: "用户id不能为空",
            trigger: "change",
          },
        ],
      },
      //新增班组房间的dialog配置
      dialogVisibleAddMonitorItemRoom: false,
      addMonitorItemRoom: {
        monitorName: "",
      },
      addMonitorItemRoomRules: {
        monitorItemName: [
          {
            required: true,
            message: "班长不能为空",
            trigger: "blur",
          },
        ],
      },
      showBuildImg: true, //所有楼栋 默认是加号
      isBuildTrueA: true, //默认是减号
      isBuildTrueB: false, //加号
      checkedRoom: [], //选中的值
      chooseRoom: [], //已选择的房间
      choosedRoomList: [], //已选择的房间数组
      itemRoomList: [],
      addBtnShow: true, //添加房间的按钮 默认可以点击
      deleteBtnShow: true, //移除房间的按钮 默认可以点击
      //新增班组成员的dialog配置
      dialogVisibleAddMonitorItemMember: false,
      addMonitorItemMemberLoading: false,
      addMonitorItemMember: {},
      addMonitorItemMemberRules: {
        nursingGroupId: [
          {
            required: true,
            message: "班组id不能为空",
            trigger: "change",
          },
        ],
      },
      checkedNursing: [],
      unNursing: [], //未绑定的护工的集合
      //更改护工班组的dialog配置
      dialogVisibleEditNursingItem: false,
      editNursingItemLoading: false,
      editNursingItem: {
        nursingName: "",
        nursingItem: "",
        userId: "",
      },
      editNursingItemRules: {},
      nursingItemOptions: [], //更改护士班组dialog中的护工班组集合

      roomList: [], //房间的集合
      columns: [], //table列的集合
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 }, //默认分页
      pageResult: {},
      buildRoomList: [], //楼栋房间
    };
  },
  methods: {
    /* 
            更换班长点击事件
        */
    handleReplaceMonitor() {
      this.dialogVisibleReplaceMonitor = true;
      this.selectShowAll();
    },

    /* 
            新增护工班组
        */
    handleAddNursingItem() {
      this.$nextTick(() => {
        if (this.$refs.addNursingItem) {
          this.$refs.addNursingItem.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.dialogVisibleAddNursingItem = true;
      this.selectShowUn(); //未分配的护工
      this.addNursingItem = {
        name: "",
        userId: "",
      };
    },

    /* 
            新增护工班组提交数据
        */
    submitFormAddNursingItem() {
      this.$refs.addNursingItem.validate((valid) => {
        if (valid) {
          console.log("adsddsf");
          this.addNursingItemLoading = true;
          let params = {};
          params = Object.assign({}, this.addNursingItem);
          let userList = [];
          userList.push({ userid: this.addNursingItem.userId });
          params.userList = userList;
          console.log(params);
          this.$postJson("omc/group/groupAdd", params).then((res) => {
            console.log(res);
            this.addNursingItemLoading = false;
            if (res.code == 200) {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisibleAddNursingItem = false;
              this.$refs["addNursingItem"].resetFields();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
            this.selectShowAll();
          });
        }
      });
    },

    /* 
            删除护工组
        */
    handleDeleteNursingItem() {
      this.$confirm("确认删除护工组吗？", "删除护工组", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let params = {};
          params.nursingGroupId = this.teamGroupRadio;
          console.log(params);
          this.$postForm("omc/group/groupDelById", params).then((res) => {
            console.log(res);
            this.selectShowAll();
          });
        })
        .catch(() => { });
    },

    /* 
            关闭新增班组房间的 dialog模态框
        */
    closeAddMonitorItemRoom() {
      console.log("关闭了");
      this.selectRooms(this.teamGroupRadio); //刷新班组负责房间的数据   传radio默认选中的值
      this.addBtnShow = true; //添加房间的按钮  将按钮初始化  by guo 2019-12-26-17:00添加
      this.deleteBtnShow = true; //移除房间的按钮 将按钮初始化 by guo 2019-12-26-17:00添加
    },

    /* 
            新增班组房间 弹出dialog模态框
        */
    handleAddMonitorItemRoom() {
      this.dialogVisibleAddMonitorItemRoom = true;
      this.addMonitorItemRoom = {
        monitorItemName: "",
      };
      this.showAllBuildRoom();
      this.checkedRoom = []; //将数据清空
      this.chooseRoom = []; //将数据清空
      this.choosedRoomList = []; //将数据清空
      //清除form表单
      this.$nextTick(() => {
        if (this.$refs.addMonitorItemRoom) {
          this.$refs.addMonitorItemRoom.resetFields();
        }
      });
    },

    /* 
            新增班组房间dialog中的下拉框的change事件   
        */
    handleChangeMonitorItemRoom(value) {
      console.log(value);
      this.monitorItemNameOptions.forEach((item) => {
        console.log(item);
        if (value == item.id) {
          this.addMonitorItemRoom.monitorName = item.realName; //获取班长名
        }
      });
      this.selectRooms(value);
    },

    /* 
            新增班组房间的dialog中所有楼栋减号小图标的点击
        */
    handleBuildMinusImg() {
      this.showBuildImg = false;
      this.isBuildTrueA = false;
      this.isBuildTrueB = true;
    },

    /* 
           新增班组房间的dialog中所有楼栋加号小图标的点击
        */
    handleBuildAddImg() {
      this.showBuildImg = true;
      this.isBuildTrueA = true;
      this.isBuildTrueB = false;
    },

    /* 
            所有楼栋房间的checkbox的change事件
        */
    handleCheckedRoom(val) {
      console.log(val);
      this.checkedRoom = val;
      this.deleteBtnShow = this.checkedRoom.length > 0 ? false : true; //当右边所有房间 有房间被选中时 删除按钮隐藏
    },

    /* 
            新增班组房间的dialog中房间减号小图标的点击
        */
    handleRoomMinusImg(index) {
      console.log(index);
      //点击动态的修改状态
      this.buildRoomList[index].showRoomImg =
        !this.buildRoomList[index].showRoomImg;
      this.buildRoomList[index].isRoomTrueA =
        !this.buildRoomList[index].isRoomTrueA;
      this.buildRoomList[index].isRoomTrueB =
        !this.buildRoomList[index].isRoomTrueB;
      this.$set(this.buildRoomList, index, this.buildRoomList[index]);
    },

    /* 
            新增班组房间的dialog中所有房间加号小图标的点击
        */
    handleRoomAddImg(index, buildingId) {
      console.log(index, buildingId);
      //点击动态的修改状态
      this.buildRoomList[index].showRoomImg =
        !this.buildRoomList[index].showRoomImg;
      this.buildRoomList[index].isRoomTrueA =
        !this.buildRoomList[index].isRoomTrueA;
      this.buildRoomList[index].isRoomTrueB =
        !this.buildRoomList[index].isRoomTrueB;
      this.$set(this.buildRoomList, index, this.buildRoomList[index]);
      this.buildRoomList.forEach((item, i) => {
        if (index != i) {
          item.showRoomImg = false;
          item.isRoomTrueA = false;
          item.isRoomTrueB = true;
        }
      });
      this.selectShowUnRoom(buildingId);
    },

    /* 
            已选择房间的change事件
        */
    handleChooseRoomList(val) {
      console.log(val);
      this.chooseRoom = val;
      this.addBtnShow = this.chooseRoom.length > 0 ? false : true; //当右边已选择的房间  又被选中时， 添加按钮隐藏
    },

    /* 
            批量添加房间提交数据
        */
    submitFormAddMonitorItemRoom() {
      this.$refs.addMonitorItemRoom.validate((valid) => {
        if (valid) {
          this.$confirm("确认要添加吗？", "新增班组房间", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
            .then(() => {
              var roomList = [];
              this.checkedRoom.forEach((item) => {
                let roomObj = {};
                roomObj.roomId = item;
                roomList.push(roomObj);
              });
              console.log(roomList);
              let params = {};
              params.nursingGroupId = this.addMonitorItemRoom.monitorItemName; //获取nursingGroupId
              params.roomList = roomList;
              console.log(params);
              this.$postJson("omc/group/groupAddRoom", params).then((res) => {
                console.log(res);
                if (res.code == 200) {
                  this.$message({ message: res.message, type: "success" });
                } else {
                  this.$message({ message: res.message, type: "error" });
                }
                this.showAllBuildRoom(); //刷新左边的楼栋房间数据
                this.selectRooms(this.addMonitorItemRoom.monitorItemName); //刷新右边的已选择房间数据
                this.checkedRoom = []; //每次提交完后清空数据，防止累加
                this.addBtnShow = true; //重置状态
                this.deleteBtnShow = true; //重置状态
              });
            })
            .catch(() => { });
        }
      });
    },

    /* 
            批量移除房间提交数据
        */
    submitFormDeleteItemRoom() {
      this.$refs.addMonitorItemRoom.validate((valid) => {
        if (valid) {
          this.$confirm("确认要移除吗？", "移除班组负责房间", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
            .then(() => {
              var roomList = [];
              this.chooseRoom.forEach((item) => {
                let roomObj = {};
                roomObj.roomId = item;
                roomList.push(roomObj);
              });
              console.log(roomList);
              let params = {};
              params.nursingGroupId = this.addMonitorItemRoom.monitorItemName; //获取nursingGroupId
              params.roomList = roomList;
              console.log(params);
              this.$postJson("omc/group/groupDelRoom", params).then((res) => {
                console.log(res);
                if (res.code == 200) {
                  this.$message({ message: res.message, type: "success" });
                } else {
                  this.$message({ message: res.message, type: "error" });
                }
                this.showAllBuildRoom(); //刷新左边的楼栋房间数据
                this.selectRooms(this.addMonitorItemRoom.monitorItemName); //刷新右边的已选择房间数据
                this.chooseRoom = []; //每次提交完后清空数据，防止累加
                this.addBtnShow = true; //重置状态
                this.deleteBtnShow = true; //重置状态
              });
            })
            .catch(() => { });
        }
      });
    },

    /* 
            新增班组成员
        */
    handleAddMonitorItemMember() {
      this.$nextTick(() => {
        if (this.$refs.addMonitorItemMember) {
          this.$refs.addMonitorItemMember.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.dialogVisibleAddMonitorItemMember = true;
      this.addMonitorItemMember = {
        nursingGroupId: "",
      };
      this.selectShowUn(); //未分配的护工
      this.checkedNursing = []; //by guo 2019-8-20 10：37 修改  打开dialog清空上一次的数据  防止数据残留
    },

    /* 
            新增班组成员提交数据
        */
    submitFormAddMonitorItemMember() {
      this.$refs.addMonitorItemMember.validate((valid) => {
        if (valid) {
          console.log(this.checkedNursing);
          this.addMonitorItemMemberLoading = true;
          let userList = [];
          this.checkedNursing.forEach((item) => {
            let itemObj = {};
            itemObj.userid = item;
            userList.push(itemObj);
          });
          let params = {};
          params = Object.assign({}, this.addMonitorItemMember);
          params.userList = userList;
          console.log(params);
          this.$postJson("omc/group/groupAddNurse", params).then((res) => {
            console.log(res);
            this.addMonitorItemMemberLoading = false;
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.dialogVisibleAddMonitorItemMember = false;
              this.$refs["addMonitorItemMember"].resetFields();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.findPage();
          });
        }
      });
    },

    /* 
            新增班组成员dialog中的下拉框的change事件
        */
    handleChangeMonitorItemMember(value) {
      console.log(value);
      this.monitorItemNameOptions.forEach((item) => {
        console.log(item);
        if (value == item.id) {
          this.addMonitorItemMember.monitorName = item.realName; //获取班长名
        }
      });
    },

    /* 
            护工的checkbox选取
        */
    handleCheckedNursing(val) {
      console.log(val);
      this.checkedNursing = val;
    },

    /* 
            护理班组减号小图标的点击
        */
    handleMinusImg() {
      this.showImg = false;
      this.isTrueA = false;
      this.isTrueB = true;
    },

    /* 
            护理班组加号小图标的点击
        */
    handleAddImg() {
      this.showImg = true;
      this.isTrueA = true;
      this.isTrueB = false;
    },

    /* 
            查询所有的护工班组
        */
    selectShowAll() {
      //请求数据之前先把数据清空
      this.teamGroupList = [];
      this.monitorItemNameOptions = [];
      this.nursingItemOptions = [];
      this.$postJson("omc/group/selectShowAll").then((res) => {
        console.log(res);
        if (res.result.length > 0) {
          res.result.forEach((item, index) => {
            if (index == 0) {
              //获取默认初始值
              this.teamGroupRadio = item.id;
              this.dataFormReplaceMonitor.monitorItemName = item.id;

            }
            var tempGroupObj = {};
            tempGroupObj.id = item.id;
            tempGroupObj.name = item.name;
            tempGroupObj.realName = item.realName; //班长名
            tempGroupObj.userId = item.userId; //班长的userId
            tempGroupObj.buserId = item.buserId; //班长的userId
            this.teamGroupList.push(tempGroupObj);
            this.monitorItemNameOptions.push(tempGroupObj);
            this.nursingItemOptions.push(tempGroupObj);
          });
        }
        console.log(this.teamGroupList);
        this.selectById(this.dataFormReplaceMonitor.monitorItemName);
        this.findPage();
        this.selectRooms(this.teamGroupRadio); //删除了护工组之后  刷新班组负责房间的数据   传radio默认选中的值
      });
    },

    /* 
            查询已经添加的房间
        */
    selectRooms(nursingGroupId) {
      let params = {};
      params.nursingGroupId = nursingGroupId;
      let RoomList = [];
      this.$postForm("omc/group/selectRooms", params).then((res) => {
        if (res.result != null) {
          res.result.forEach((item, index) => {
            if (item !== null) {
              RoomList.push(item);
            }
          });
        }
        this.roomList = RoomList;
        this.choosedRoomList = RoomList;
      });
    },

    /* 
            所有班组radio的change事件
        */
    changeRadio(value) {
      console.log(value);
      this.selectRooms(value);
      this.findPage();
    },

    /* 
            查询未被分配的护工
        */
    selectShowUn() {
      this.undistributedList = []; //每次请求之前先清空
      this.unNursing = []; //清空数据
      this.$postForm("omc/group/selectNursingShowAll").then((res) => {
        console.log(res);
        let undistributedList = res.result;
        for (var i = 0; i < undistributedList.length; i++) {
          if (i == 0) {
            this.addNursingItem.userId = undistributedList[i].userId;
          }
          var item = {};
          item.value = undistributedList[i].userId;
          item.label = undistributedList[i].realName;
          this.undistributedList.push(item);
          console.log(this.addNursingItem.userId);
          this.unNursing.push(item);
        }
      });
    },

    /* 
            更换护工组，对应的切换护工班长
        */
    handleChangeMonitorItemName(value) {
      console.log(value);
      this.selectById(value);
    },
    /* 
            查询护工组护工
        */
    selectById(val) {
      let params = {};
      params.nursingGroupId = val;
      params.pageNo = "";
      params.pageSize = "";
      console.log(params);
      console.log(this.monitorItemNameOptions);
      this.monitorNameOptions = []; //请求数据之前先把数据置空
      this.$postJson("omc/group/selectById", params).then((res) => {
        res.result.list.forEach((item, index) => {
          this.monitorItemNameOptions.forEach((temp) => {
            console.log(item.userId, temp.userId);
            if (item.userId == temp.userId) {
              //通过护工组中班长的userId和当前护工的userId比较 如果相等 就将值赋给this.dataFormReplaceMonitor.monitorName  回显
              this.dataFormReplaceMonitor.monitorName = item.userId;
            }
            if (item.userId == temp.buserId) {
              //通过护工组中班长的userId和当前护工的userId比较 如果相等 就将值赋给this.dataFormReplaceMonitor.monitorName  回显
              this.dataFormReplaceMonitor.monitorNameb = item.userId;
            }
          });
          var monitorNameObj = {};
          monitorNameObj.userId = item.userId;
          monitorNameObj.realName = item.realName;
          this.monitorNameOptions.push(monitorNameObj);
        });
      });
    },

    /* 
            更换班长提交数据
        */
    submitFormReplaceMonitor() {
      this.$refs.dataFormReplaceMonitor.validate((valid) => {
        if (valid) {
          console.log("8888888888");
          this.replaceMonitorLoading = true;
          let params = {};
          params.nursingGroupId = this.dataFormReplaceMonitor.monitorItemName; //护工组id
          params.userId = this.dataFormReplaceMonitor.monitorName; //护工id
          console.log(params);
          this.$postForm("omc/group/updateById", params).then((res) => {
            this.replaceMonitorLoading = false;
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisibleReplaceMonitor = false;
              this.$refs["dataFormReplaceMonitor"].resetFields();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
          });
        }
      });
    },

    /* 
            获取所有护工的table
        */

    findPage(data) {
      console.log(data);
      console.log(
        this.pageRequest,
        this.teamGroupRadio,
        "this.teamGroupRadio----------------------------"
      );
      let params = {};
      params.pageNo = this.pageRequest.pageNum;
      params.pageSize = this.pageRequest.pageSize;
      params.nursingGroupId = this.teamGroupRadio;
      console.log(params);
      // this.pageResult = {}; //by yang 2021-10-12 13:19 修改 会导致分页出现bug
      this.$postJson("omc/group/selectById", params).then((res) => {
        console.log(res.result);
        if (res.result != null && res.result.list != null) {
          res.result.list.forEach((item) => {
            item.duty = "护士";
            item.sex == 0 ? (item.sex = "女") : (item.sex = "男");
          });
          //将值赋给this.pageResult这个对象
          this.pageResult = res.result;
          this.pageResult.pageNum = res.result.pageNo;
          this.pageResult.total = res.result.totalCount;
          console.log(this.pageResult, "--------=====");
        } else {
          this.pageResult = {}; //by guo 2019-11-02-15:28 注释  有bug
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
      // .then(data != null ? data.callback : "");
    },

    /* 
            分页刷新数据
        */
    refreshPageRequest(data) {
      // console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage(data);
    },

    /* 
            移除护工
        */
    handleRemove(data) {
      console.log(data);
      var params = {};
      params.userId = data.row.userId;
      params.nursingGroupId = data.row.id;
      console.log(params);
      this.$confirm("确定要移除护工吗？", "移除护工", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$postForm("omc/group/updateByUserId", params).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
            this.findPage(); //刷新数据
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除",
          });
        });
    },

    /* 
            显示编辑界面
        */
    handleEdit(params) {
      console.log(params);
      this.dialogVisibleEditNursingItem = true;
      this.editNursingItem = Object.assign({}, params.row);
      this.editNursingItem.nursingName = params.row.realName;
      this.editNursingItem.userId = params.row.userId;
      this.editNursingItem.nursingItem = params.row.nursingGroupId;
      console.log(this.editNursingItem.nursingItem);
    },

    /* 
            更改护士护工班组提交数据
        */
    submitFormEditNursingItem() {
      let params = {};
      params.userId = this.editNursingItem.userId;
      params.nursingGroupId = this.editNursingItem.nursingItem;
      console.log(params);
      this.$postForm("omc/group/updateByUserId", params).then((res) => {
        console.log(res);
        this.dialogVisibleEditNursingItem = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
        this.findPage(); //刷新数据
      });
    },

    /* 
            获取所有楼栋信息
        */
    showAllBuildRoom() {
      let params = {};
      params.buildingName = "";
      this.$postForm("omc/Building/showAll", params).then((res) => {
        console.log(res);
        this.buildRoomList = res.result; //获取楼栋房间的数据
        this.buildRoomList.forEach((item) => {
          item.showRoomImg = false;
          item.isRoomTrueA = false;
          item.isRoomTrueB = true;
        });
      });
    },

    /* 
            查询未被分配的房间
        */
    selectShowUnRoom(buildingId) {
      let params = {};
      params.buildingId = buildingId;
      //  改成查询全部房间
      this.$postJson("omc/Room/queryRoomInfo", params).then((res) => {
        this.itemRoomList = res.result;
      });

    },

    /* 
            修改表格的头部颜色
        */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    /* 
            修改table tr行的背景色
        */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },

    /* 
            处理表格列过滤显示 
        */

    initColumns: function () {
      this.columns = [
        { prop: "realName", label: "姓名", minWidth: 100 },
        { prop: "nursingGroupName", label: "班组", minWidth: 100 },
        { prop: "identityNumber", label: "身份证号", minWidth: 150 },
        { prop: "phone", label: "联系方式", minWidth: 120 },
        { prop: "sex", label: "性别", minWidth: 100 },
        { prop: "duty", label: "职务", minWidth: 100 },
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },
  },
  created() {
    this.initColumns();
    this.selectShowAll();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        console.log(this.teamGroupRadio, "*************");
        this.selectRooms(this.teamGroupRadio);
      }, 500);
    });
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

.nursingmanagement {
  .cell {
    line-height: 40px;
  }

  min-width: 1360px;
  min-height: 500px;
  background: #fefefe;

  .nursingmanagement-left {
    float: left;
    width: 21%;
    height: 100%;
    border: 1px #f1eff2 solid;
    margin-right: 1%;
    box-sizing: border-box;
    min-height: 500px;

    .teamGroupListA {
      opacity: 1;
      margin: 10px 0 10px 5px;
    }

    .teamGroupListB {
      opacity: 0;
      transition: 0.3s;
      margin: 10px 0 10px 5px;
    }
  }

  .nursingmanagement-right {
    float: right;
    width: 74%;
    height: 100%;
    margin-right: 2%;
    box-sizing: border-box;

    .item {
      width: 10%;
      height: 60px;
      text-align: center;
      float: left;
      margin-top: 15px;
      margin-bottom: 5px;

      img {
        height: 40px;
        line-height: 40px;
      }

      div {
        height: 20px;
        line-height: 20px;
      }
    }
  }

  .roomInfo {
    border: 1px solid #ccc;

    .roomInfoText {
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid #ccc;
    }

    .roomInfoContent {
      height: 260px;
      overflow-y: auto;
      overflow-x: hidden;

      .buildRoomListA {
        opacity: 1;
      }

      .buildRoomListB {
        display: none;
      }

      .checkboxRoom {
        width: 40%;
        margin: 3px auto;
      }

      .buildingName {
        margin-top: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }

      .roomNo {
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }

      .roomListA {
        opacity: 1;
      }

      .roomListB {
        display: none;
      }
    }
  }

  .btn {
    height: 300px;

    .addBtn {
      padding-top: 100px;
    }

    .deleteBtn {
      margin-top: 20px;
    }
  }
}
</style>
